<template>
  <div class='feedback-container'>
    <div class="input-item">
      <span>反馈类型</span>
      <span @click='selectType'>{{type}}</span>
      <van-popup v-model="slType" position="bottom" :overlay="true">
          <van-picker show-toolbar title="请选择反馈类型" :columns="columns1" @cancel="cancelProduct" @confirm="confirmProduct"
        />
      </van-popup>
    </div>
    <div class="input-item">
      <span>您的姓名</span>
      <input placeholder="请输入您的姓名">
    </div>
    <div class="input-item">
      <span>联系电话</span>
      <input placeholder="请输入联系电话">
    </div>
    <div class="textarea-item">
      <span>反馈内容</span>
      <textarea placeholder="请输入反馈内容"></textarea>
    </div>
    <div class="textarea-item">
      <span>图片附件（可选）</span>
      <div class='addimage'>
        <div v-for="(item, index) in images" :key="index" style="position: relative;">
          <img class="main-image" :src="item" @click="previewImage(index)"/>
          <img src="../../assets/img/img_upload_delete.png" class="del-image" @click.stop="deleteImage(index)">
        </div>
        <van-uploader :after-read="onRead">
          <img class="main-image" :src="image"/>
        </van-uploader>
      </div>
    </div>
    <div class="footer">
      <button>提交问题反馈</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { Area, Popup, Picker, Toast, Uploader } from 'vant'
import { ImagePreview } from 'vant'

Vue.use(Popup).use(Area).use(Picker).use(Uploader).use(Toast)
export default {
  name: 'Feedback',
  data() {
    return {
      images: [],
      columns1: ['功能使用', '产品使用'],
      columns2: ['假货', '价格不对', '货不对板'],
      slType: false,
      slCity: false,
      slReport: false,
      type: '请选择反馈类型',
      city: '请选择店铺地址',
      reportType: '请选择举报类型',
      image: require('../../assets/img/img_upload_btn.png')
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    selectType() {
      this.slType = true
    },
    selectCity() {
      this.slCity = true
    },
    selectReport() {
      this.slReport = true
    },
    confirmProduct(value) {
      this.slType = false
      this.type = value
    },
    cancelProduct() {
      this.slType = false
    },
    confirmArea(data) {
      this.slCity = false
      this.city = data[0].name + ' ' + data[1].name + ' ' + data[2].name
    },
    cancelArea() {
      this.slCity = false
    },
    cancelReport() {
      this.slReport = false
    },
    confirmReport(val) {
      this.slReport = false
      this.reportType = val
    },
    onRead(file) {
      console.log(file)
      if (this.images.length < 9) {
        this.images.push(file.content)
      } else {
        Toast('最多上传9张图片')
      }
    },
    previewImage(index) {
      ImagePreview({
        images: this.images,
        startPosition: index,
        loop: false
      })
    },
    deleteImage(index) {
      this.images.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.feedback-container{
  height: auto;
  .input-item{
    height: 44px;
    padding: 0 20px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      color: #000000;
      font-size: 14px;
      font-weight: 400;
    }
    input{
      width: 250px;
      // color: #747474;
      font-size: 14px;
      font-weight: 400;
      text-align: right;
    }
  }
  .textarea-item{
    background-color: #ffffff;
    line-height: 44px;
    margin-bottom: 1px;
    span{
      color: #000000;
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
    }
    textarea{
      width: 90%;
      height: 80px;
      padding: 10px;
      font-size: 14px;
      border-color: #ffffff;
      resize: none;
      display: block;
      margin: 0 auto;
    }
    .addimage{
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      .add{
        line-height: 0px;
        display: inline-block;
        margin: 28px 15px;
        font-size: 40px;
        color: #dddddd;
      }
      .main-image{
        width: 60px;
        height: 60px;
        margin: 0 8px 8px 0;
      }
      .del-image{
        width: 25px;
        height: 25px;
        position: absolute;
        top: 0;
        right: 6px;
      }
    }
  }
  .footer{
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    button{
      width: 175px;
      height: 45px;
      border-radius: 5px;
      background-color: #5e5ef6;
      color: #ffffff;
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/feedback.vue